


















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { db, firestore } from "@/scripts/firebase";
import { JinroPlayerDocument, JinroRoomDocument } from "@/services/datatypes";
import { JinroPlayerParams } from "@/services/paramstypes";
import { collectionName } from "@/services/collection-name";
import { InputFieldErrorMessages } from "@/services/vue-messages";
import { DialogProgrammatic as Dialog } from "buefy";
import JoinPublicViewing from "@/components/JinroRoom/ManageJinroPlayers/JoinPublicViewing.vue";

@Component({
  components: {
    JoinPublicViewing
  }
})
export default class HandleGuestForm extends Vue {
  @Prop() readonly jinroRoom!: JinroRoomDocument;
  @Prop() readonly buttonLabel!: string;
  @Prop() readonly buttonType!: string;
  @Prop() readonly isRedirectAfterAdded!: boolean;
  @Prop() readonly isPublicViewingButtonAllowed!: boolean;

  guestName = "";

  get hasUser(): boolean {
    return !!this.$store.state.firebaseUser;
  }

  get inputMessage(): string {
    return this.isPlyaerNameDuplicated
      ? InputFieldErrorMessages.duplicatedPlayerName
      : "";
  }

  get players(): Array<JinroPlayerDocument> {
    if (this.$store.state.jinroRoomPlayers) {
      return this.$store.state.jinroRoomPlayers;
    }
    return [];
  }

  get inputType(): string {
    return this.isPlyaerNameDuplicated ? "is-danger" : "";
  }

  get isPlyaerNameDuplicated(): boolean {
    const duplicated = this.players.find(player => {
      return player.playerName === this.guestName;
    });
    return duplicated ? true : false;
  }

  get isOwner() {
    if (!this.jinroRoom) {
      return false;
    }
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom.owner === this.$store.state.firebaseUser.uid
    );
  }

  async handleGuestJoin() {
    this.checkIntentionWithDiaglogue(this.guestName);
  }

  checkIntentionWithDiaglogue(guestName: string) {
    Dialog.confirm({
      message: this.checkIntentionDialogueMessage(guestName),
      cancelText: "キャンセル",
      confirmText: this.checkIntentionDialogueButton,
      onConfirm: async () => this.createGuestPlayer()
    });
  }

  checkIntentionDialogueMessage(guestName: string): string {
    if (this.isOwner) {
      return ` 「<b>${guestName}</b>」をゲストプレイヤーとして作成しますか`;
    }
    return ` 「<b>${guestName}</b>」としてゲームに参加しますか`;
  }

  get checkIntentionDialogueButton(): string {
    if (this.isOwner) {
      return "作成する";
    }
    return "参加する";
  }

  async createGuestPlayer(): Promise<void> {
    const guestName = this.guestName;
    this.guestName = "";

    const playerParams: JinroPlayerParams = {
      uid: null,
      isGuest: true,
      isDeleted: false,
      playerName: guestName,
      jinroRoomId: this.$route.params.jinroRoomId,
      timeCreated: firestore.FieldValue.serverTimestamp()
    };
    const doc = await db
      .collection(collectionName.jinrorooms)
      .doc(this.$route.params.jinroRoomId)
      .collection(collectionName.jinroplayers)
      .add({
        ...playerParams
      });

    if (this.isRedirectAfterAdded) {
      this.frindlyRedirecting(guestName, doc.id);
    }
  }

  frindlyRedirecting(guestName: string, playerId: string) {
    Dialog.confirm({
      message: `「<b>${guestName}</b>」が作成されました。プレイ画面に遷移します。</br></br>※遷移後のURLを無くした場合、ゲームに参加できなくなります。</br> ※遷移後のURLは、他人から聞かれても絶対に教えないでください。ゲスト参加者の画面のため、どなたでも開くことができます</br>※現在ご利用されている端末以外からでも、遷移後のURLにアクセスすればゲームをプレイすることができます。また、同時に複数の端末からアクセスしても問題なくプレイできます。`,
      canCancel: false,
      confirmText: "遷移する",
      onConfirm: async () => this.$router.push(`/p/${playerId}`)
    });
  }

  get isFormEmply(): boolean {
    return this.guestName === "";
  }
}
